/**
 * Money, in euros, everywhere.
 *
 * NCMB invoices in euros and pays its contractors in euros, so there is one
 * currency in this application and no reason for any screen to choose its own.
 * Four components had each written their own identical `money` helper and two
 * other screens had quietly stayed on dollars - the analytics tile and the
 * contractor rate on the settings page - which made the same hourly rate read
 * as $50 in one place and €50 in another.
 *
 * NUMERIC arrives from node-postgres as a string, so everything here goes
 * through Number() first: `rate.toFixed(2)` on a string is the crash that took
 * out the contractors list once already.
 */
const EUR = '€';

/** €1,234.56. A value that is not a number at all reads as a dash. */
export const money = (v, { dash = '—' } = {}) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return dash;
  return `${EUR}${n.toLocaleString('en-IE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

/** €1,235 - for headline figures, where the cents are noise. */
export const moneyRound = (v, { dash = '—' } = {}) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return dash;
  return `${EUR}${Math.round(n).toLocaleString('en-IE')}`;
};

/** €50.00/hr */
export const rate = (v, { dash = '—' } = {}) => {
  const m = money(v, { dash });
  return m === dash ? dash : `${m}/hr`;
};

export const CURRENCY_SYMBOL = EUR;

export default money;
